import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeVariations'
})
export class FilterPipeVariations implements PipeTransform {
    transform(variations: any, term?: any): any {
        if (term === undefined) return variations;
        if (term === null) return variations;

        if (variations != null) {
            return variations.filter(function (variation) {
                if (variation.name != undefined)
                    if (variation.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return variation;
                if (variation.price != undefined)
                    if (variation.price.toString().toLowerCase().includes(term.toLowerCase()))
                        return variation;
                if (variation.type != undefined)
                    if (variation.type.toString().toLowerCase().includes(term.toLowerCase()))
                        return variation;
                if (variation.measurement != undefined)
                    if (variation.measurement.toString().toLowerCase().includes(term.toLowerCase()))
                        return variation;
                if (variation.quantity != undefined)
                    if (variation.quantity.toString().toLowerCase().includes(term.toLowerCase()))
                        return variation;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-variations/filter.pipe.ts